import type { Requests } from "../common/request.common";
import type { FinanceInvoiceResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const financeInvoice = {
    record(data: typeof Requests.FinanceInvoice.Record.Input) {
        return post<typeof data, FinanceInvoiceResponseTypes.Record>(
            `/finance-invoice/record`,
            data,
        );
    },
    create(data: typeof Requests.FinanceInvoice.Create.Input) {
        return post<typeof data>(`/finance-invoice/create`, data);
    },
    obtain(id: string) {
        return get<FinanceInvoiceResponseTypes.Obtain>(`/finance-invoice/obtain/${id}`);
    },
    payment(id: string, data: typeof Requests.FinanceInvoice.Payment.Input) {
        return post<typeof data>(`/finance-invoice/payment/${id}`, data);
    },
    waive(id: string) {
        return postEmpty(`/finance-invoice/waive/${id}`);
    },
    revert(id: string) {
        return postEmpty(`/finance-invoice/revert/${id}`);
    },
    cancel(id: string) {
        return postEmpty(`/finance-invoice/cancel/${id}`);
    },
};
